import type { UmbracoFormPropsApi } from '@omnia/ui/src/lib/cms/components/umbracoForm/models'
import { UmbracoForm as OmniaUiUmbracoForm } from '@omnia/ui/src/lib/cms/components/umbracoForm/UmbracoForm'
import type { GridElement } from '@omnia/ui/src/lib/cms/grid/interfaces/gridElement'
import type { FC } from 'react'

export const UmbracoForm: FC<GridElement<UmbracoFormPropsApi['form']>> = props => {
    return <OmniaUiUmbracoForm form={props.value} />
}
